import React, { useEffect } from "react";
import { useContext } from "react";
import { MyContext } from "../../context/MyContext";

const Document = () => {
  const { verifyMlmUser } = useContext(MyContext);
  const documents = [
    { title: "PAN", file: "/PAN.pdf" },
    { title: "TAN", file: "/TAN.pdf" },
    {
      title: "Certificate of Incorporation",
      file: "/Certificate of Incorporation.pdf",
    },
    { title: "MicroLife Msme", file: "/microlife msme.pdf" },
  ];
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Forces no animation
    });
  }, [])
  return (
    <div className={`p-6 ${verifyMlmUser ? "lg:pt-[100px]" : "lg:pt-40"}`}>
      <h1 className="text-2xl text-center font-semibold mb-4 lg:text-center">
        Documents
      </h1>
      <table className="min-w-full table-auto border-[1.5px] border-gray-900 rounded-lg">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border text-justify">S.No.</th>
            <th className="px-4 py-2 border text-justify">Document Name</th>
            <th className="px-4 py-2 border text-justify">View</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((doc, index) => (
            <tr key={index} className="text-justify border-[2px]">
              <td className="px-4 py-2 border">{index + 1}</td>
              <td className="px-4 py-2 border">{doc.title}</td>
              <td className="px-4 py-2 border">
                <a
                  href={doc.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white bg-blue-500 px-4 py-1 rounded hover:bg-blue-600">
                  View</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Document;